import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
	Button,
	Drawer,
	ConfigProvider,
	theme,
	Tooltip,
	Select,
	Typography,
	Switch,
} from 'antd';
import './topnav.css';
import {
	TeamOutlined,
	QuestionOutlined,
	GlobalOutlined
} from '@ant-design/icons';
import TimeRangeModal from './modal/TimeRangeModal';
import ParentMenu from '../help/ParentMenu';

import {
	userSideNav,
	userUpdateOrganization,
	userUpdateTheme,
	userUpdateSelectedHostname,
	userUpdateEnv,
	userLogin,
} from '../../modules/user';

import {
	trendCDNGetList
} from '../../modules/analytics';

import {
	inspectionTimeUpdate
} from '../../modules/analytics';

const { Option } = Select;
const { Text } = Typography;
class TopNav extends Component {

	constructor(props) {
		super(props);
		this.state = {
			fullscreen: false,
			addTimeRangeModal: false,
			env: process.env.NODE_ENV === 'production' ? 'prod' : 'uat',
			selectedHostname: this.props.selectedHostname || null,
			loading: true
		};
	}

	componentDidMount() {
		const { env } = this.state;
		localStorage.setItem('env', env);
	}

	componentDidUpdate(prevProps) {
		const { organizations, selectedOrganization } = this.props;
		if (JSON.stringify(selectedOrganization) !== JSON.stringify(prevProps.selectedOrganization)) {
			let organization = organizations.find(org => (org.code === selectedOrganization));
			localStorage.setItem('apiKey', localStorage.env === 'live' ? organization.apiKey : organization.apiKeySandbox);
		}
	}

	onSelectOrganization(value) {
		const { inspectionTime } = this.props;
		this.props.userUpdateOrganization(value);
		this.props.inspectionTimeUpdate(inspectionTime);
	}


	onUpdateTheme(checked) {
		this.props.userUpdateTheme((checked) ? 'light' : 'dark');
	};

	onUpdateEnv(env) {
		this.props.userUpdateEnv(env);
		this.setState({ env: env });
		// const {inspectionTime } = this.props;
		// this.props.inspectionTimeUpdate(inspectionTime);
	};


	goTeam() {
		this.props.history.push('/organization');
	}


	toggleTimeRangeModal = () => {
		const { addTimeRangeModal } = this.state;
		this.setState({ addTimeRangeModal: !addTimeRangeModal });
	}
	showDrawer = () => {
		this.setState({ open: true });
	};
	onClose = () => {
		this.setState({ open: false });
	};


	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const { simple, userProfile, organizations, selectedOrganization, userTheme, appTitle } = this.props;
		let { addTimeRangeModal } = this.state;
		let organization = organizations.find(org => (org.code === selectedOrganization));
		if (localStorage.apiKey === undefined) {
			if (organization !== undefined) {
				localStorage.setItem('apiKey', localStorage.env === 'live' ? organization.apiKey : organization.apiKeySandbox);
			}
		}
		let org_name = (organizations.find(org => org.code === selectedOrganization)) ? organizations.find(org => org.code === selectedOrganization).name : selectedOrganization;
		const menuItems = (organizations) ? organizations.map(org => ({
			key: org.code,
			label: <div key={org.code} onClick={() => { this.onSelectOrganization(org.code) }}>{org.name}</div>
		})
		) : [];


		if (simple || !userProfile || !userProfile.user) {
			return (
				<div className="topNavWrapper">
					<div className="topNavTitle">
					</div>
				</div>
			);
		} else {
			return (
				<ConfigProvider theme={{
					algorithm: userTheme === 'dark' ? darkAlgorithm : defaultAlgorithm,
				}}>
					<div className="topNavWrapper">
						<div className="topNavTitle">{appTitle && appTitle.title} {appTitle && appTitle.showOrg && <b>{` - ${selectedOrganization.toUpperCase()}`}</b>}</div>
						<h4 className="headerContentHolder">
							{
								['/advertisement'].includes(window.location.pathname) &&
								<Switch
									checkedChildren='Production'
									unCheckedChildren={<span style={{ color: userTheme === 'light' ? 'black' : 'white' }} >Sandbox</span>}
									checked={this.state.env === 'prod'}
									onChange={(va) => {
										this.onUpdateEnv(this.state.env === 'prod' ? 'uat' : 'prod')
									}
									}
								/>
							}
							{/* <Button shape="round" size={`small`} icon={<TeamOutlined />}  className="seleterHolder" disabled>
						{org_name}
					</Button>
					<Tooltip title="Help">
						<Button shape="circle" size={`small`} icon={<QuestionOutlined />} className="questionIcon" onClick={this.showDrawer}/>
					</Tooltip>
					<Drawer title="Help" width={350} closable={false} onClose={this.onClose} open={this.state.open}>
						<ParentMenu/>
					</Drawer> */}
						</h4>
						<TimeRangeModal
							show={addTimeRangeModal}
							toggleTimeRangeModal={this.toggleTimeRangeModal.bind(this)}
						/>
					</div>

				</ConfigProvider>
			);
		}
	}

}

const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userNav: state.user.userNav,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	userTheme: state.user.userTheme,
	appTitle: state.user.appTitle,
	organizations: state.organization.organizations,
	inspectionTime: state.analytics.inspectionTime,
});



const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userSideNav,
			userUpdateOrganization,
			userUpdateTheme,
			inspectionTimeUpdate,
			trendCDNGetList,
			userUpdateSelectedHostname,
			userLogin,
			userUpdateEnv,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopNav));
